export const modalPaddingSm = 20;
export const modalPadding = 50;
